import { jsx as e, jsxs as a } from "react/jsx-runtime";
import { _ as h } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import u from "../Description/index.js";
import f from "../Heading/index.js";
import _ from "../InlineView/index.js";
import n from "../ListView/index.js";
import k from "../PageContainer/index.js";
import '../../index45.css';const w = "_page-header_1t13u_1", b = "_heading_1t13u_2", d = {
  pageHeader: w,
  heading: b
};
function P(l) {
  const {
    className: m,
    heading: t,
    description: r,
    actions: i,
    breadCrumbs: o,
    info: s,
    wikiLink: c,
    background: p,
    headingColorVariant: g
  } = l;
  return i || o || s || r || t ? /* @__PURE__ */ e(
    k,
    {
      containerAs: "header",
      className: h(
        d.pageHeader,
        m
      ),
      background: p,
      children: /* @__PURE__ */ a(
        n,
        {
          layout: "block",
          spacing: "xl",
          children: [
            /* @__PURE__ */ e(
              _,
              {
                after: (i || c) && /* @__PURE__ */ a(
                  n,
                  {
                    withWrap: !0,
                    spacing: "sm",
                    children: [
                      i,
                      c
                    ]
                  }
                ),
                wrapBreakpoint: "lg",
                children: o
              }
            ),
            /* @__PURE__ */ a(
              n,
              {
                layout: "block",
                children: [
                  /* @__PURE__ */ e(
                    f,
                    {
                      level: 1,
                      className: d.heading,
                      colorVariant: g,
                      children: t
                    }
                  ),
                  r && /* @__PURE__ */ e(u, { withCenteredContent: !0, children: r })
                ]
              }
            ),
            s
          ]
        }
      )
    }
  ) : null;
}
export {
  P as default
};
